var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var InputBorder = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  height: 48px;\n  transition: border-color 0.3s ease-out;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n"], ["\n  background: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  height: 48px;\n  transition: border-color 0.3s ease-out;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n"])), function (_a) {
  var theme = _a.theme,
    error = _a.error;
  return error ? theme.tokens.interface.feedback.negative.lightest : theme.tokens.space.surface.regular;
}, function (_a) {
  var theme = _a.theme,
    focus = _a.focus,
    error = _a.error,
    disabled = _a.disabled;
  return disabled ? theme.tokens.interface.neutral.light : error ? theme.tokens.interface.feedback.negative.strong : focus ? theme.tokens.interface.neutral.strong : theme.tokens.interface.neutral.regular;
});
var templateObject_1;